(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["video"] && !Shopify.designMode) return;
  try {
    function handleSlideMediaVisibility(slide) {
    if (!slide.closest('media-gallery')) return;

    const deferred = slide.querySelector('deferred-media');
    if (!deferred) return;

    const isVisible = slide.getAttribute('aria-hidden') === 'false';
    const video = deferred.querySelector('video');

    if (isVisible) {
      if (video) {
        video.play().catch(() => {});
      } else {
        const playButton = deferred.querySelector('[ref="deferredMediaPlayButton"]');
        if (playButton) {
          playButton.click();
          const newVideo = deferred.querySelector('video');
          if (newVideo) newVideo.play().catch(() => {});
        }
      }
    } else if (video && !video.paused) {
      video.pause();
      video.currentTime = 0;
    }
  }

  const slideVisibilityObserver = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      if (
        mutation.type === 'attributes' &&
        mutation.attributeName === 'aria-hidden' &&
        mutation.target.tagName === 'SLIDESHOW-SLIDE'
      ) {
        handleSlideMediaVisibility(mutation.target);
      }
    });
  });

  slideVisibilityObserver.observe(document.body, {
    attributes: true,
    attributeFilter: ['aria-hidden'],
    subtree: true,
  });

  document
    .querySelectorAll('slideshow-slide[aria-hidden="false"]')
    .forEach(handleSlideMediaVisibility);
  } catch(e) { console.error(e); }
})();

})();
